<template>
  <!-- Se App.vue já tem <v-app>, troque esta tag por <div class="bg-white"> -->
  <v-app
    :class="[
      showClientLogin
        ? 'bg-client-light d-flex flex-column min-vh-100'
        : 'bg-white',
      {
        'exemplar-login-app': isBrandedLogin,
        'preserve-login-app': isPreserveLogin,
        'cajupe-login-app': !showClientLogin && !isRecoveryRoute,
      },
    ]"
    :style="loginThemeStyle"
  >
    <!-- Overlay GLOBAL super simples (cobre a tela toda) -->
    <div v-if="loading" class="global-spinner">
      <v-progress-circular indeterminate size="64" width="6" color="primary" />
    </div>

    <router-view v-if="isRecoveryRoute" />

    <!-- Layout Cliente -->
    <template v-else-if="showClientLogin">
      <v-container
        fluid
        class="login-container-client flex-grow-1"
        :class="{ 'exemplar-login-container': isBrandedLogin }"
      >
        <v-row
          align="center"
          justify="center"
          :no-gutters="isBrandedLogin"
          :class="{ 'exemplar-login-row': isBrandedLogin }"
        >
          <v-col
            v-if="isBrandedLogin"
            cols="12"
            md="7"
            class="pa-0 exemplar-login-visual"
          >
            <img
              :src="whiteLabelBrand.landingCover"
              :alt="localizedBrand.landingCoverAlt"
              class="exemplar-login-visual-image"
            />
            <div class="exemplar-login-visual-copy">
              <h1>
                {{
                  $t("publicPages.login.welcomeBrand", {
                    brand: whiteLabelBrand.displayName,
                  })
                }}
              </h1>
              <p v-if="localizedBrand.loginPromoText">
                {{ localizedBrand.loginPromoText }}
              </p>
            </div>
          </v-col>

          <v-col
            cols="12"
            :sm="isBrandedLogin ? 12 : 8"
            :md="isBrandedLogin ? 5 : 4"
            class="text-center"
            :class="{ 'exemplar-login-form-panel': isBrandedLogin }"
          >
            <div :class="{ 'exemplar-login-form': isBrandedLogin }">
              <v-img
                eager
                :src="logoPath"
                :alt="whiteLabelBrand.logoAlt"
                :max-width="logoWidth"
                class="mb-6 mx-auto"
                :class="{ 'exemplar-login-logo': isBrandedLogin }"
                contain
              />
              <div v-if="isBrandedLogin" class="exemplar-login-kicker">
                {{ $t("publicPages.login.secureAccess") }}
              </div>
              <v-card
                class="mx-auto px-4 py-5"
                :class="{ 'exemplar-login-card': isBrandedLogin }"
              >
                <h4
                  class="mb-2 font-weight-bolder"
                  :class="{ 'exemplar-login-title': isBrandedLogin }"
                >
                  {{ clientWelcomeTitle }}
                </h4>
                <p v-if="isBrandedLogin" class="exemplar-login-description">
                  {{ $t("publicPages.login.credentialsInstruction") }}
                </p>

                <form @submit.prevent="login">
                  <div v-for="(error, i) in errors" :key="i">
                    <base-material-alert color="error" dark dismissible>
                      <span>{{ error.fieldName }}</span> {{ error.message }}
                    </base-material-alert>
                  </div>

                  <div class="pb-4">
                    <label class="text-xs font-weight-bolder ms-1">
                      {{ $t("publicPages.login.cpf") }}
                    </label>
                    <v-text-field
                      :disabled="loading"
                      hide-details
                      outlined
                      background-color="rgba(255,255,255,.9)"
                      color="rgba(0,0,0,.6)"
                      light
                      height="40"
                      v-model="cliente.email"
                      :error="validarCamposLogin && cpfLoginVazio"
                      :placeholder="$t('publicPages.login.cpf')"
                      class="
                        input-style
                        font-size-input
                        border border-radius-md
                        placeholder-lighter
                        text-color-light
                        mb-4
                        mt-2
                      "
                      :class="{ 'exemplar-login-input': isBrandedLogin }"
                    />

                    <label class="text-xs font-weight-bolder ms-1">
                      {{ $t("Senha") }}
                    </label>
                    <v-text-field
                      :disabled="loading"
                      hide-details
                      outlined
                      background-color="rgba(255,255,255,.9)"
                      color="rgba(0,0,0,.6)"
                      light
                      height="40"
                      v-model="cliente.senha"
                      :error="validarCamposLogin && senhaLoginVazia"
                      :placeholder="$t('Senha')"
                      type="password"
                      class="
                        input-style
                        font-size-input
                        border border-radius-md
                        placeholder-lighter
                        text-color-light
                        mb-4
                        mt-2
                      "
                      :class="{ 'exemplar-login-input': isBrandedLogin }"
                    />

                    <div v-if="aguardandoEscolhaCanal2FA">
                      <base-material-alert color="info" dark>
                        {{ $t("Escolha_canal_autenticacao") }}
                      </base-material-alert>
                      <v-select
                        v-model="cliente.canalAutenticacaoDoisFatores"
                        :items="canais2FA"
                        item-text="descricao"
                        item-value="canal"
                        :label="$t('Canal_autenticacao')"
                        :disabled="loading"
                        outlined
                      />
                    </div>

                    <div v-if="aguardandoCodigo2FA">
                      <base-material-alert color="info" dark>
                        {{
                          mensagemCodigo2FA || $t("Codigo_autenticacao_enviado")
                        }}
                      </base-material-alert>
                      <label class="text-xs font-weight-bolder ms-1">
                        {{ $t("Codigo_autenticacao") }}
                      </label>
                      <v-text-field
                        :disabled="loading"
                        hide-details
                        outlined
                        background-color="rgba(255,255,255,.9)"
                        color="rgba(0,0,0,.6)"
                        light
                        height="40"
                        v-model="cliente.codigoAutenticacaoDoisFatores"
                        :placeholder="$t('Codigo_autenticacao')"
                        inputmode="numeric"
                        maxlength="6"
                        autocomplete="one-time-code"
                        class="
                          input-style
                          font-size-input
                          border border-radius-md
                          placeholder-lighter
                          text-color-light
                          mb-4
                          mt-2
                        "
                        :class="{ 'exemplar-login-input': isBrandedLogin }"
                      />
                    </div>

                    <v-btn
                      elevation="0"
                      :ripple="false"
                      :height="isBrandedLogin ? 48 : 39"
                      type="submit"
                      class="
                        font-weight-bold
                        text-uppercase
                        white--text
                        py-2
                        px-6
                        me-2
                        mt-7
                        mb-2
                        w-100
                        btn-client
                      "
                      :class="{ 'exemplar-login-submit': isBrandedLogin }"
                      :style="{ backgroundColor: clientButtonColor }"
                      small
                      :disabled="loading"
                      :loading="loading"
                    >
                      {{
                        aguardandoCodigo2FA
                          ? $t("Validar_codigo")
                          : aguardandoEscolhaCanal2FA
                          ? $t("Enviar_codigo")
                          : $t("publicPages.login.signIn")
                      }}
                    </v-btn>

                    <div class="text-center mt-2">
                      <router-link
                        class="text-body text-decoration-underline"
                        :class="{
                          'exemplar-login-recovery-link': isBrandedLogin,
                        }"
                        :to="passwordRecoveryRoute"
                      >
                        {{ $t("Esqueceu_a_senha?") }}
                      </router-link>
                    </div>
                  </div>
                </form>

                <div class="text-center">
                  <div class="text-sm mt-3 mb-0">
                    <select
                      v-model="selectedLocale"
                      :aria-label="$t('publicPages.common.languageSelector')"
                      :disabled="loading"
                      :class="{ 'exemplar-login-language': isBrandedLogin }"
                    >
                      <option
                        v-for="(lang, i) in langs"
                        :key="`Lang${i}`"
                        :value="lang.item"
                      >
                        {{ lang.description }}
                      </option>
                    </select>
                  </div>
                </div>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <content-footer
        auth
        :white-label-brand="whiteLabelBrand"
        v-if="!$route.meta.hideFooter"
      />
    </template>

    <!-- Layout Cajupe -->
    <template v-else>
      <v-container fluid class="cajupe-login-container flex-grow-1">
        <v-row no-gutters class="cajupe-login-shell">
          <v-col cols="12" md="5" class="cajupe-login-form-panel">
            <div class="cajupe-login-form">
              <div class="cajupe-login-brand" aria-label="Cajupe">
                <img :src="cajupeMark" alt="" />
                <span>Cajupe<sup>®</sup></span>
              </div>

              <div class="cajupe-login-heading">
                <span>{{ $t("publicPages.login.platformAccess") }}</span>
                <h1>{{ $t("publicPages.login.welcomeCajupe") }}</h1>
                <p>{{ $t("publicPages.login.operationAccess") }}</p>
              </div>

              <v-card class="cajupe-login-card">
                <form @submit.prevent="login">
                  <div v-for="(error, i) in errors" :key="i">
                    <base-material-alert color="error" dark dismissible>
                      <span>{{ error.fieldName }}</span> {{ error.message }}
                    </base-material-alert>
                  </div>

                  <div class="pb-3">
                    <label class="cajupe-login-label">
                      {{ $t("publicPages.login.cpf") }}
                    </label>
                    <v-text-field
                      v-model="cliente.email"
                      :error="validarCamposLogin && cpfLoginVazio"
                      :disabled="loading"
                      hide-details
                      outlined
                      background-color="#fbf9f8"
                      color="#a11d16"
                      light
                      height="46"
                      :placeholder="$t('publicPages.login.cpfPlaceholder')"
                      class="
                        cajupe-login-input
                        input-style
                        font-size-input
                        mb-4
                        mt-2
                      "
                    />

                    <label class="cajupe-login-label">
                      {{ $t("Senha") }}
                    </label>
                    <v-text-field
                      v-model="cliente.senha"
                      :error="validarCamposLogin && senhaLoginVazia"
                      :disabled="loading"
                      hide-details
                      outlined
                      background-color="#fbf9f8"
                      color="#a11d16"
                      light
                      height="46"
                      :placeholder="$t('Senha')"
                      type="password"
                      class="
                        cajupe-login-input
                        input-style
                        font-size-input
                        mb-4
                        mt-2
                      "
                    />

                    <div v-if="aguardandoEscolhaCanal2FA">
                      <base-material-alert color="info" dark>
                        {{ $t("Escolha_canal_autenticacao") }}
                      </base-material-alert>
                      <v-select
                        v-model="cliente.canalAutenticacaoDoisFatores"
                        :items="canais2FA"
                        item-text="descricao"
                        item-value="canal"
                        :label="$t('Canal_autenticacao')"
                        :disabled="loading"
                        outlined
                      />
                    </div>

                    <div v-if="aguardandoCodigo2FA">
                      <base-material-alert color="info" dark>
                        {{
                          mensagemCodigo2FA || $t("Codigo_autenticacao_enviado")
                        }}
                      </base-material-alert>
                      <label class="cajupe-login-label">
                        {{ $t("Codigo_autenticacao") }}
                      </label>
                      <v-text-field
                        v-model="cliente.codigoAutenticacaoDoisFatores"
                        :disabled="loading"
                        hide-details
                        outlined
                        background-color="#fbf9f8"
                        color="#a11d16"
                        light
                        height="46"
                        :placeholder="$t('Codigo_autenticacao')"
                        inputmode="numeric"
                        maxlength="6"
                        autocomplete="one-time-code"
                        class="
                          cajupe-login-input
                          input-style
                          font-size-input
                          mb-4
                          mt-2
                        "
                      />
                    </div>

                    <v-btn
                      elevation="0"
                      :ripple="false"
                      height="50"
                      type="submit"
                      class="
                        cajupe-login-submit
                        font-weight-bold
                        text-uppercase
                        white--text
                        w-100
                        mt-4
                        mb-3
                      "
                      color="#a11d16"
                      :disabled="loading"
                      :loading="loading"
                    >
                      {{
                        aguardandoCodigo2FA
                          ? $t("Validar_codigo")
                          : aguardandoEscolhaCanal2FA
                          ? $t("Enviar_codigo")
                          : $t("publicPages.login.signIn")
                      }}
                      <v-icon right size="15">fas fa-arrow-right</v-icon>
                    </v-btn>

                    <div class="text-center">
                      <router-link
                        class="cajupe-login-recovery"
                        :to="passwordRecoveryRoute"
                      >
                        {{ $t("Esqueceu_a_senha?") }}
                      </router-link>
                    </div>
                  </div>
                </form>

                <div class="cajupe-login-language">
                  <v-icon size="13">fas fa-globe-americas</v-icon>
                  <select
                    v-model="selectedLocale"
                    :disabled="loading"
                    :aria-label="$t('publicPages.common.languageSelector')"
                  >
                    <option
                      v-for="(lang, i) in langs"
                      :key="`Lang${i}`"
                      :value="lang.item"
                    >
                      {{ lang.description }}
                    </option>
                  </select>
                </div>
              </v-card>
            </div>
          </v-col>

          <v-col cols="12" md="7" class="cajupe-login-visual">
            <div class="cajupe-login-visual-copy">
              <span>{{ $t("publicPages.login.connectingManagement") }}</span>
              <h2>
                {{ $t("publicPages.login.moreClarity") }}<br />
                {{ $t("publicPages.login.moreControl") }}
              </h2>
              <p>
                {{ $t("publicPages.login.marketingDescription") }}
              </p>
            </div>

            <div class="cajupe-login-preview" aria-hidden="true">
              <div class="cajupe-login-preview-header">
                <div><i></i><i></i><i></i></div>
                <strong>{{ $t("publicPages.common.operationsCenter") }}</strong>
                <span>{{ $t("publicPages.common.online") }}</span>
              </div>
              <div class="cajupe-login-preview-body">
                <div class="cajupe-login-preview-cards">
                  <div>
                    <v-icon size="16">fas fa-clock</v-icon>
                    <span>
                      {{ $t("publicPages.common.workSchedules") }}
                      <strong>{{ $t("publicPages.common.upToDate") }}</strong>
                    </span>
                  </div>
                  <div>
                    <v-icon size="16">fas fa-file-alt</v-icon>
                    <span>
                      {{ $t("publicPages.login.documents") }}
                      <strong>{{ $t("publicPages.login.organized") }}</strong>
                    </span>
                  </div>
                  <div>
                    <v-icon size="16">fas fa-tasks</v-icon>
                    <span>
                      {{ $t("publicPages.common.tasks") }}
                      <strong>{{ $t("publicPages.common.activeFlow") }}</strong>
                    </span>
                  </div>
                </div>
                <div class="cajupe-login-preview-activity">
                  <small>{{ $t("publicPages.common.recentActivity") }}</small>
                  <div>
                    <span><i></i></span>
                    <p></p>
                    <em>{{ $t("publicPages.common.now") }}</em>
                  </div>
                  <div>
                    <span><i></i></span>
                    <p></p>
                    <em>{{ $t("publicPages.common.fiveMinutesAgo") }}</em>
                  </div>
                  <div>
                    <span><i></i></span>
                    <p></p>
                    <em>{{ $t("publicPages.common.twelveMinutesAgo") }}</em>
                  </div>
                </div>
              </div>
            </div>

            <div class="cajupe-login-connected">
              <span><v-icon size="17">fas fa-check</v-icon></span>
              <p>
                <small>{{
                  $t("publicPages.login.integratedEnvironment")
                }}</small>
                <strong>{{
                  $t("publicPages.login.everythingConnected")
                }}</strong>
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <content-footer
        auth
        :white-label-brand="whiteLabelBrand"
        v-if="!$route.meta.hideFooter"
      />
    </template>
  </v-app>
</template>

<script>
import ContentFooter from "@/components/Footer.vue";
import { LANGUAGE_OPTIONS, saveLocale } from "@/utils/locale";
import {
  getPasswordRecoveryRouteByBrand,
  getLocalizedWhiteLabelText,
  isClientWhiteLabel,
  resolveAppWhiteLabelBrand,
} from "@/utils/whiteLabel";
import { askAndRegisterTrustedDevice } from "@/utils/twoFactorTrustedDevice";

export default {
  name: "page-layout",
  components: { ContentFooter },
  data() {
    return {
      errors: [],
      langs: LANGUAGE_OPTIONS,
      cliente: {
        email: "",
        senha: "",
        codigoAutenticacaoDoisFatores: "",
        canalAutenticacaoDoisFatores: "",
        confiarDispositivoAutenticacaoDoisFatores: false,
        descricaoDispositivoAutenticacaoDoisFatores: "",
      },
      aguardandoCodigo2FA: false,
      aguardandoEscolhaCanal2FA: false,
      canais2FA: [],
      mensagemCodigo2FA: "",
      loading: false,
      validarCamposLogin: false,
    };
  },
  methods: {
    hexToRgb(color) {
      const normalized = String(color || "")
        .replace("#", "")
        .trim();
      const hex =
        normalized.length === 3
          ? normalized
              .split("")
              .map((character) => character + character)
              .join("")
          : normalized;
      const value = Number.parseInt(hex, 16);

      if (hex.length !== 6 || Number.isNaN(value)) {
        return "39, 43, 92";
      }

      return `${(value >> 16) & 255}, ${(value >> 8) & 255}, ${value & 255}`;
    },
    async login() {
      if (this.loading) return;
      this.errors = [];

      if (this.cpfLoginVazio || this.senhaLoginVazia) {
        this.validarCamposLogin = true;
        this.errors.push({
          message: this.$t("Preencha_todos_os_campos_obrigatorios"),
        });
        return;
      }
      this.validarCamposLogin = false;
      this.loading = true;

      // força o repaint antes da request
      await this.$nextTick();
      await new Promise((r) => requestAnimationFrame(r));

      try {
        const passouPor2FA = this.aguardandoCodigo2FA;
        const payload = this.limpaMascara({ ...this.cliente });
        payload.escolherCanalAutenticacaoDoisFatores = true;
        if (!this.aguardandoEscolhaCanal2FA && !this.aguardandoCodigo2FA) {
          delete payload.canalAutenticacaoDoisFatores;
        }
        if (!this.aguardandoCodigo2FA) {
          delete payload.codigoAutenticacaoDoisFatores;
        }
        delete payload.confiarDispositivoAutenticacaoDoisFatores;
        delete payload.descricaoDispositivoAutenticacaoDoisFatores;
        await this.$store.dispatch("AUTH_REQUEST", payload);
        this.aguardandoCodigo2FA = false;
        this.aguardandoEscolhaCanal2FA = false;
        this.mensagemCodigo2FA = "";
        this.cliente.confiarDispositivoAutenticacaoDoisFatores = false;
        this.cliente.descricaoDispositivoAutenticacaoDoisFatores = "";
        if (passouPor2FA) {
          this.loading = false;
          await askAndRegisterTrustedDevice(this);
        }
        this.$router.push("/dashboard");
      } catch (error) {
        console.log(error);
        if (this.tratarRespostaAutenticacaoDoisFatores(error)) {
          return;
        }
        this.errors.push({
          message: this.$t(
            error?.profileLoadFailed
              ? "Favor_tente_novamente_mais_tarde"
              : "Usuario_ou_senha_invalidos"
          ),
          //  fieldName: this.$t("Usuario_ou_senha_invalidos"),
        });
      } finally {
        this.loading = false;
      }
    },
    tratarRespostaAutenticacaoDoisFatores(error) {
      const data = error?.response?.data || {};
      if (!error?.twoFactorRequired && !data?.autenticacaoDoisFatores) {
        return false;
      }

      if (data.status === "TWO_FACTOR_CHANNEL_REQUIRED") {
        this.canais2FA = (data.canaisAutenticacaoDoisFatores || []).map((item) => ({
          ...item,
          descricao: `${item.canal} · ${item.destinoMascarado}`,
        }));
        this.cliente.canalAutenticacaoDoisFatores = this.canais2FA[0]?.canal || "";
        this.aguardandoEscolhaCanal2FA = true;
        this.aguardandoCodigo2FA = false;
        this.errors = [];
        return true;
      }
      if (this.aguardandoEscolhaCanal2FA && !error?.twoFactorRequired) {
        this.errors = [{ message: data.message || this.$t("Codigo_autenticacao_invalido") }];
        return true;
      }

      this.aguardandoCodigo2FA = true;
      this.aguardandoEscolhaCanal2FA = false;
      this.mensagemCodigo2FA =
        data.message || this.$t("Codigo_autenticacao_enviado");
      this.cliente.codigoAutenticacaoDoisFatores = "";
      this.cliente.confiarDispositivoAutenticacaoDoisFatores = false;
      this.cliente.descricaoDispositivoAutenticacaoDoisFatores = "";
      this.errors = [];

      if (!error?.twoFactorRequired) {
        this.errors.push({
          message: data.message || this.$t("Codigo_autenticacao_invalido"),
        });
      }
      return true;
    },
  },
  computed: {
    cpfLoginVazio() {
      return !String(this.cliente.email || "").trim();
    },
    senhaLoginVazia() {
      return !String(this.cliente.senha || "").trim();
    },
    isRecoveryRoute() {
      return (
        this.$route?.name === "Esqueceu.senha" ||
        this.$route?.path === "/recuperar-senha"
      );
    },
    whiteLabelBrand() {
      return resolveAppWhiteLabelBrand();
    },
    localizedBrand() {
      return ["landingCoverAlt", "loginPromoText"].reduce((content, field) => {
        content[field] = getLocalizedWhiteLabelText(
          this.whiteLabelBrand,
          field,
          this.$i18n
        );
        return content;
      }, {});
    },
    selectedLocale: {
      get() {
        return this.$i18n.locale;
      },
      set(locale) {
        this.$i18n.locale = saveLocale(locale);
      },
    },
    showClientLogin() {
      return isClientWhiteLabel(this.whiteLabelBrand);
    },
    isBrandedLogin() {
      return (
        this.showClientLogin &&
        ["editorial-cover", "secure-cover"].includes(
          this.whiteLabelBrand.loginVariant
        ) &&
        Boolean(this.whiteLabelBrand.landingCover)
      );
    },
    isPreserveLogin() {
      return (
        this.isBrandedLogin &&
        this.whiteLabelBrand.loginVariant === "secure-cover"
      );
    },
    loginThemeStyle() {
      if (!this.isBrandedLogin) {
        return null;
      }

      const primary =
        this.whiteLabelBrand.dashboardPrimaryColor ||
        this.whiteLabelBrand.authButtonColor ||
        "#272b5c";
      const accent =
        this.whiteLabelBrand.authAccentColor ||
        this.whiteLabelBrand.dashboardAccentColor ||
        primary;

      return {
        "--auth-primary": primary,
        "--auth-primary-rgb": this.hexToRgb(primary),
        "--auth-accent": accent,
        "--auth-accent-rgb": this.hexToRgb(accent),
      };
    },
    passwordRecoveryRoute() {
      return getPasswordRecoveryRouteByBrand(this.whiteLabelBrand);
    },
    cajupeMark() {
      return require("@/assets/Cajupe_simples.png");
    },
    logoPath() {
      return this.showClientLogin
        ? this.whiteLabelBrand.authLogo
        : require("@/assets/cajupe-logo.png");
    },
    buttonColor() {
      return this.showClientLogin
        ? this.whiteLabelBrand.authButtonColor || "#253077"
        : "#575f6b";
    },
    clientButtonColor() {
      return this.whiteLabelBrand.authButtonColor || "#253077";
    },
    logoWidth() {
      return this.showClientLogin
        ? this.whiteLabelBrand.authLogoWidth || 260
        : 200;
    },
    clientWelcomeTitle() {
      return this.$t("publicPages.login.internalSystemWelcome", {
        brand: this.whiteLabelBrand.displayName,
      });
    },
  },
};
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  min-height: 100%;
}
.min-vh-100 {
  min-height: 100vh;
}

/* Overlay global fixo */
.global-spinner {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(20, 20, 20, 0.08);
  z-index: 999999;
}

/* Login principal Cajupe */
.cajupe-login-app {
  height: 100vh;
  height: 100dvh;
  min-height: 0 !important;
  overflow: hidden;
  background: #f5f0ee !important;
}

.cajupe-login-app .v-application--wrap {
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.cajupe-login-container {
  display: flex;
  min-height: 0;
  padding: clamp(0.75rem, 1.5vw, 1.5rem) !important;
}

.cajupe-login-shell {
  width: 100%;
  max-width: 1500px;
  height: 100%;
  min-height: 0;
  margin: auto !important;
  overflow: hidden;
  border: 1px solid rgba(161, 29, 22, 0.09);
  border-radius: 30px;
  background: #ffffff;
  box-shadow: 0 30px 80px rgba(69, 30, 27, 0.14);
}

.cajupe-login-form-panel {
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 0;
  padding: clamp(2rem, 4.3vw, 5rem) !important;
  background: radial-gradient(
      circle at 0 0,
      rgba(240, 100, 69, 0.1),
      transparent 27%
    ),
    #ffffff;
}

.cajupe-login-form {
  width: 100%;
  max-width: 430px;
  max-height: 100%;
  margin: auto;
  padding: 0.25rem;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(161, 29, 22, 0.18) transparent;
}

.cajupe-login-brand {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  color: #922019;
}

.cajupe-login-brand img {
  width: 34px;
  height: 48px;
  object-fit: contain;
}

.cajupe-login-brand span {
  font-size: 1.45rem;
  font-weight: 850;
  line-height: 1;
  letter-spacing: -0.045em;
}

.cajupe-login-brand sup {
  top: -0.65em;
  margin-left: 0.1rem;
  font-size: 0.45em;
}

.cajupe-login-heading {
  margin: clamp(1.5rem, 3.5vh, 2.8rem) 0 clamp(1.25rem, 3vh, 2.2rem);
  text-align: left;
}

.cajupe-login-heading > span {
  color: #a11d16;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.cajupe-login-heading h1 {
  margin: 0.55rem 0 0.65rem;
  color: #293047;
  font-size: clamp(1.9rem, 2.8vw, 2.65rem);
  font-weight: 850;
  line-height: 1.08;
  letter-spacing: -0.04em;
}

.cajupe-login-heading p {
  margin: 0;
  color: #777d8e;
  font-size: 0.95rem;
  line-height: 1.6;
}

.cajupe-login-card {
  max-width: none !important;
  padding: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  text-align: left;
}

.cajupe-login-label {
  margin-left: 0.15rem;
  color: #4c5265;
  font-size: 0.74rem;
  font-weight: 800;
  letter-spacing: 0.025em;
}

.cajupe-login-input .v-input__slot {
  border-radius: 12px !important;
  background: #fbf9f8 !important;
}

.cajupe-login-input fieldset {
  border-color: #e8e0de !important;
}

.cajupe-login-input.v-input--is-focused fieldset {
  border-width: 1px !important;
  border-color: #a11d16 !important;
}

.cajupe-login-submit {
  border-radius: 13px !important;
  box-shadow: 0 15px 30px rgba(161, 29, 22, 0.24) !important;
  letter-spacing: 0.06em;
}

.cajupe-login-submit:hover {
  box-shadow: 0 18px 38px rgba(161, 29, 22, 0.31) !important;
  transform: translateY(-1px);
}

.cajupe-login-recovery {
  color: #6e7281 !important;
  font-size: 0.82rem;
  font-weight: 650;
  text-decoration: none;
}

.cajupe-login-recovery:hover {
  color: #a11d16 !important;
}

.cajupe-login-language {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin-top: clamp(1rem, 2.2vh, 1.6rem);
  color: #9a9eaa;
}

.cajupe-login-language .v-icon {
  color: #a11d16;
}

.cajupe-login-language select {
  color: #797e8d;
  font-size: 0.76rem;
  outline: none;
}

.cajupe-login-visual {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  min-height: 0;
  padding: clamp(3rem, 5vw, 5.5rem) !important;
  overflow: hidden;
  color: #ffffff;
  background: radial-gradient(
      circle at 92% 10%,
      rgba(255, 189, 168, 0.28),
      transparent 31%
    ),
    radial-gradient(circle at 10% 92%, rgba(79, 8, 5, 0.36), transparent 35%),
    linear-gradient(140deg, #8f1812 0%, #b72b1e 48%, #e15a3d 100%);
}

.cajupe-login-visual::before {
  position: absolute;
  inset: 0;
  opacity: 0.2;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.15) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(255, 255, 255, 0.15) 1px, transparent 1px);
  background-size: 44px 44px;
  mask-image: linear-gradient(135deg, transparent, #000 32%, transparent 94%);
  content: "";
}

.cajupe-login-visual::after {
  position: absolute;
  top: -11vw;
  right: -8vw;
  width: clamp(280px, 32vw, 520px);
  height: clamp(280px, 32vw, 520px);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 50%;
  box-shadow: 0 0 0 70px rgba(255, 255, 255, 0.025),
    0 0 0 140px rgba(255, 255, 255, 0.018);
  content: "";
}

.cajupe-login-visual-copy {
  position: relative;
  z-index: 2;
  max-width: 680px;
}

.cajupe-login-visual-copy > span {
  display: inline-flex;
  margin-bottom: 0.8rem;
  padding: 0.5rem 0.72rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  color: rgba(255, 255, 255, 0.88);
  background: rgba(255, 255, 255, 0.09);
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.cajupe-login-visual-copy h2 {
  margin: 0;
  color: #ffffff;
  font-size: clamp(2rem, 3.5vw, 3.7rem);
  font-weight: 850;
  line-height: 1.02;
  letter-spacing: -0.05em;
}

.cajupe-login-visual-copy p {
  max-width: 610px;
  margin: 1rem 0 0;
  color: rgba(255, 255, 255, 0.75);
  font-size: clamp(0.95rem, 1.2vw, 1.08rem);
  line-height: 1.6;
}

.cajupe-login-preview {
  position: relative;
  z-index: 2;
  width: min(100%, 720px);
  margin-top: clamp(1.8rem, 4vh, 3rem);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 28px 65px rgba(71, 9, 7, 0.31);
  backdrop-filter: blur(16px);
}

.cajupe-login-preview-header {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  min-height: 50px;
  padding: 0 1.1rem;
  border-bottom: 1px solid #eee7e5;
  color: #44495c;
  font-size: 0.73rem;
}

.cajupe-login-preview-header > div {
  display: flex;
  gap: 0.32rem;
}

.cajupe-login-preview-header i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #e7d9d6;
}

.cajupe-login-preview-header i:first-child {
  background: #a11d16;
}

.cajupe-login-preview-header > span {
  justify-self: end;
  color: #408563;
  font-size: 0.65rem;
  font-weight: 800;
}

.cajupe-login-preview-body {
  padding: clamp(1rem, 2vw, 1.5rem);
  background: #faf8f7;
}

.cajupe-login-preview-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem;
}

.cajupe-login-preview-cards > div {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-width: 0;
  padding: 0.8rem;
  border: 1px solid #eee7e5;
  border-radius: 12px;
  color: #a11d16;
  background: #ffffff;
}

.cajupe-login-preview-cards span {
  min-width: 0;
  overflow: hidden;
  color: #9498a5;
  font-size: 0.63rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cajupe-login-preview-cards strong {
  display: block;
  margin-top: 0.13rem;
  overflow: hidden;
  color: #40465a;
  font-size: 0.72rem;
  text-overflow: ellipsis;
}

.cajupe-login-preview-activity {
  margin-top: 0.65rem;
  padding: 0.9rem 1rem 0.45rem;
  border: 1px solid #eee7e5;
  border-radius: 12px;
  background: #ffffff;
}

.cajupe-login-preview-activity > small {
  color: #8e93a2;
  font-size: 0.64rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.cajupe-login-preview-activity > div {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 0.65rem;
  padding: 0.48rem 0;
  border-bottom: 1px solid #f1eceb;
}

.cajupe-login-preview-activity > div:last-child {
  border-bottom: 0;
}

.cajupe-login-preview-activity div > span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 7px;
  background: rgba(161, 29, 22, 0.08);
}

.cajupe-login-preview-activity div > span i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #a11d16;
}

.cajupe-login-preview-activity p {
  width: min(100%, 280px);
  height: 6px;
  margin: 0;
  border-radius: 999px;
  background: linear-gradient(90deg, #e9e2e0 62%, #f5f1f0 62%);
}

.cajupe-login-preview-activity em {
  color: #aaaeba;
  font-size: 0.61rem;
  font-style: normal;
}

.cajupe-login-connected {
  position: absolute;
  z-index: 3;
  right: clamp(1.5rem, 3.5vw, 4rem);
  bottom: clamp(1.5rem, 4vh, 3rem);
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 0.65rem;
  min-width: 200px;
  padding: 0.75rem 0.9rem;
  border: 1px solid rgba(161, 29, 22, 0.1);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 16px 38px rgba(71, 9, 7, 0.25);
}

.cajupe-login-connected > span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  color: #a11d16;
  background: rgba(161, 29, 22, 0.08);
}

.cajupe-login-connected .v-icon {
  color: #a11d16;
}

.cajupe-login-connected p {
  margin: 0;
}

.cajupe-login-connected small,
.cajupe-login-connected strong {
  display: block;
}

.cajupe-login-connected small {
  color: #999daa;
  font-size: 0.59rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.cajupe-login-connected strong {
  margin-top: 0.1rem;
  color: #40465a;
  font-size: 0.73rem;
}

.cajupe-login-app .v-footer {
  margin-top: 0 !important;
  padding: 0.5rem 1.5rem !important;
  background: transparent !important;
}

/* White-label cliente */
.bg-client-light {
  background-color: #f6f6f6 !important;
}
.login-container-client {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.btn-client {
  color: #ffffff !important;
}

/* Login editorial para clientes white-label com capa personalizada */
.exemplar-login-app {
  height: 100vh;
  height: 100dvh;
  min-height: 0 !important;
  overflow: hidden;
  background: #eef0f7 !important;
}

.exemplar-login-app .v-application--wrap {
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.login-container-client.exemplar-login-container {
  align-items: stretch !important;
  min-height: 0;
  overflow: hidden;
  padding: clamp(0.75rem, 1.5vw, 1.5rem) !important;
}

.exemplar-login-row {
  width: 100%;
  height: 100%;
  max-width: 1480px;
  min-height: 0;
  max-height: 100%;
  margin: auto !important;
  overflow: hidden;
  border: 1px solid rgba(var(--auth-primary-rgb), 0.08);
  border-radius: 28px;
  background: #ffffff;
  box-shadow: 0 12px 28px -12px rgba(var(--auth-primary-rgb), 0.22);
}

.exemplar-login-visual {
  position: relative;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: var(--auth-primary);
}

.exemplar-login-visual::after {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(var(--auth-primary-rgb), 0.04) 28%,
    rgba(var(--auth-primary-rgb), 0.9) 100%
  );
  content: "";
}

.exemplar-login-visual-image {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
  object-fit: cover;
  object-position: center top;
}

.exemplar-login-visual-copy {
  position: absolute;
  z-index: 1;
  right: clamp(2rem, 5vw, 5rem);
  bottom: clamp(2rem, 6vh, 4rem);
  left: clamp(2rem, 5vw, 5rem);
  max-width: 620px;
  color: #ffffff;
  text-align: left;
}

.exemplar-login-kicker {
  color: var(--auth-accent);
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.exemplar-login-visual-copy h1 {
  margin: 0.75rem 0;
  color: #ffffff;
  font-size: clamp(2rem, 3.2vw, 3.4rem);
  line-height: 1.08;
}

.exemplar-login-visual-copy p {
  max-width: 520px;
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: clamp(1rem, 1.2vw, 1.15rem);
  line-height: 1.6;
}

.exemplar-login-form-panel {
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  padding: clamp(1.25rem, 3vw, 3rem) !important;
  background: radial-gradient(
      circle at 100% 0,
      rgba(var(--auth-accent-rgb), 0.1),
      transparent 24%
    ),
    #ffffff;
}

.exemplar-login-form {
  width: 100%;
  max-width: 440px;
  max-height: 100%;
  margin: auto;
  padding: 0.25rem 0.5rem;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(var(--auth-primary-rgb), 0.22) transparent;
}

.exemplar-login-logo {
  width: min(100%, 290px);
  margin-bottom: clamp(0.75rem, 2vh, 1.25rem) !important;
}

.exemplar-login-kicker {
  margin-bottom: 0.5rem;
  text-align: left;
}

.exemplar-login-card {
  max-width: none !important;
  padding: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  text-align: left;
}

.exemplar-login-title {
  color: var(--auth-primary);
  font-size: clamp(1.45rem, 2vw, 2rem);
  line-height: 1.25;
}

.exemplar-login-description {
  margin: 0 0 clamp(0.75rem, 2vh, 1.25rem);
  color: #74778a;
  font-size: 0.95rem;
}

.exemplar-login-input .v-input__slot {
  border-radius: 12px !important;
  background: #f7f8fb !important;
}

.exemplar-login-input fieldset {
  border-color: #dfe2ed !important;
}

.exemplar-login-input.v-input--is-focused fieldset {
  border-color: var(--auth-accent) !important;
}

.exemplar-login-submit {
  border-radius: 12px !important;
  box-shadow: 0 14px 30px rgba(var(--auth-primary-rgb), 0.24) !important;
  letter-spacing: 0.06em;
}

.exemplar-login-recovery-link {
  color: var(--auth-primary) !important;
  font-weight: 600;
}

.exemplar-login-language {
  padding: 0.4rem 0.75rem;
  border: 1px solid #dfe2ed;
  border-radius: 9px;
  color: #606477;
  background: #f7f8fb;
}

.exemplar-login-app .v-footer {
  margin-top: 0 !important;
  padding: 0.5rem 1.5rem !important;
  background: transparent !important;
}

.preserve-login-app {
  background: var(--auth-primary) !important;
}

.preserve-login-app .exemplar-login-row {
  border-color: rgba(var(--auth-accent-rgb), 0.42);
  background: #ffffff;
  box-shadow: 0 12px 28px -12px rgba(8, 12, 40, 0.5);
}

.preserve-login-app .exemplar-login-visual {
  order: 2;
  border-left: 2px solid var(--auth-accent);
}

.preserve-login-app .exemplar-login-visual::after {
  background: linear-gradient(
      180deg,
      rgba(var(--auth-primary-rgb), 0.02) 32%,
      rgba(var(--auth-primary-rgb), 0.9) 100%
    ),
    linear-gradient(90deg, rgba(var(--auth-primary-rgb), 0.14), transparent 50%);
}

.preserve-login-app .exemplar-login-visual-image {
  object-position: 68% center;
}

.preserve-login-app .exemplar-login-form-panel {
  order: 1;
  background: radial-gradient(
      circle at 0 0,
      rgba(var(--auth-accent-rgb), 0.12),
      transparent 26%
    ),
    #ffffff;
}

.preserve-login-app .exemplar-login-logo {
  width: min(100%, 158px);
  filter: drop-shadow(0 12px 24px rgba(var(--auth-primary-rgb), 0.18));
}

.preserve-login-app .exemplar-login-kicker {
  color: #a77e16;
}

.preserve-login-app .exemplar-login-submit {
  border-bottom: 3px solid var(--auth-accent) !important;
}

.preserve-login-app .v-footer {
  color: rgba(255, 255, 255, 0.8) !important;
  background: transparent !important;
}

.preserve-login-app .v-footer a,
.preserve-login-app .v-footer .public-footer__inner {
  color: rgba(255, 255, 255, 0.8) !important;
}

@media (max-width: 1199px) {
  .cajupe-login-form-panel,
  .cajupe-login-visual {
    padding: clamp(2rem, 4vw, 3.5rem) !important;
  }

  .cajupe-login-visual-copy h2 {
    font-size: clamp(2rem, 3.6vw, 3rem);
  }

  .cajupe-login-connected {
    right: 1.25rem;
    bottom: 1.25rem;
  }
}

@media (max-width: 959px) {
  .cajupe-login-app {
    height: auto;
    min-height: 100vh !important;
    min-height: 100dvh !important;
    overflow: auto;
  }

  .cajupe-login-app .v-application--wrap {
    height: auto;
    min-height: 100vh;
    min-height: 100dvh;
    overflow: visible;
  }

  .cajupe-login-container {
    min-height: auto;
    padding: 1rem !important;
  }

  .cajupe-login-shell {
    height: auto;
    min-height: 0;
    border-radius: 22px;
  }

  .cajupe-login-form-panel {
    order: 2;
    height: auto;
    padding: clamp(2.5rem, 8vw, 4.5rem) !important;
  }

  .cajupe-login-form {
    max-height: none;
    overflow: visible;
  }

  .cajupe-login-visual {
    order: 1;
    height: clamp(410px, 54vh, 520px);
    padding: clamp(2rem, 6vw, 3.5rem) !important;
  }

  .cajupe-login-visual-copy {
    max-width: 620px;
  }

  .cajupe-login-visual-copy h2 {
    font-size: clamp(2rem, 6vw, 3.25rem);
  }

  .cajupe-login-preview {
    width: min(100%, 660px);
    margin-top: 1.5rem;
  }

  .cajupe-login-connected {
    display: none;
  }

  .exemplar-login-app {
    height: auto;
    min-height: 100vh !important;
    min-height: 100dvh !important;
    overflow: auto;
  }

  .exemplar-login-app .v-application--wrap {
    height: auto;
    min-height: 100vh;
    min-height: 100dvh;
    overflow: visible;
  }

  .login-container-client.exemplar-login-container {
    min-height: auto;
    overflow: visible;
    padding: 1rem !important;
  }

  .exemplar-login-row {
    height: auto;
    max-height: none;
    min-height: 0;
    border-radius: 22px;
  }

  .exemplar-login-visual {
    height: clamp(210px, 30vh, 300px);
    min-height: 0;
  }

  .exemplar-login-visual-image {
    min-height: 100%;
    object-position: center top;
  }

  .exemplar-login-visual-copy {
    right: 1.5rem;
    bottom: 1.5rem;
    left: 1.5rem;
  }

  .exemplar-login-visual-copy h1 {
    margin-bottom: 0;
    font-size: clamp(1.5rem, 5vw, 2.1rem);
  }

  .exemplar-login-visual-copy p {
    display: none;
  }

  .exemplar-login-form-panel {
    height: auto;
    overflow: visible;
    padding: clamp(2rem, 7vw, 3.5rem) !important;
  }

  .exemplar-login-form {
    max-height: none;
    overflow: visible;
  }

  .preserve-login-app .exemplar-login-visual {
    order: 1;
    border-bottom: 2px solid var(--auth-accent);
    border-left: 0;
  }

  .preserve-login-app .exemplar-login-form-panel {
    order: 2;
  }

  .preserve-login-app .exemplar-login-visual-image {
    object-position: center center;
  }
}

@media (max-width: 599px) {
  .cajupe-login-container {
    padding: 0.5rem !important;
  }

  .cajupe-login-shell {
    border-radius: 18px;
  }

  .cajupe-login-visual {
    height: 285px;
    padding: 1.5rem !important;
  }

  .cajupe-login-visual-copy > span {
    margin-bottom: 0.55rem;
    padding: 0.4rem 0.6rem;
    font-size: 0.61rem;
  }

  .cajupe-login-visual-copy h2 {
    font-size: clamp(1.75rem, 8.6vw, 2.35rem);
    line-height: 1.04;
  }

  .cajupe-login-visual-copy p {
    margin-top: 0.7rem;
    font-size: 0.84rem;
    line-height: 1.45;
  }

  .cajupe-login-preview {
    display: none;
  }

  .cajupe-login-form-panel {
    padding: 2.25rem 1.35rem !important;
  }

  .cajupe-login-brand img {
    width: 30px;
    height: 43px;
  }

  .cajupe-login-brand span {
    font-size: 1.3rem;
  }

  .cajupe-login-heading {
    margin: 1.5rem 0 1.35rem;
  }

  .cajupe-login-heading h1 {
    font-size: 1.85rem;
  }

  .cajupe-login-submit {
    width: 100%;
  }

  .exemplar-login-visual {
    height: 190px;
  }

  .exemplar-login-logo {
    width: min(100%, 280px);
  }

  .exemplar-login-form-panel {
    padding: 2rem 1.25rem !important;
  }

  .preserve-login-app .exemplar-login-logo {
    width: 120px;
  }
}

/*
 * Em desktops com pouca altura útil, deixa o documento crescer e rolar como
 * um todo. Assim formulário, ação principal e recuperação de senha não ficam
 * presos dentro de um painel com rolagem interna praticamente invisível.
 */
@media (min-width: 960px) and (max-height: 860px) {
  .cajupe-login-app,
  .exemplar-login-app {
    height: auto;
    min-height: 100vh !important;
    min-height: 100dvh !important;
    overflow: visible;
  }

  .cajupe-login-app .v-application--wrap,
  .exemplar-login-app .v-application--wrap {
    height: auto;
    min-height: 100vh;
    min-height: 100dvh;
    overflow: visible;
  }

  .cajupe-login-container,
  .login-container-client.exemplar-login-container {
    flex-grow: 0 !important;
    min-height: 690px;
    overflow: visible;
  }

  .cajupe-login-shell,
  .exemplar-login-row {
    height: auto;
    min-height: 650px;
    max-height: none;
  }

  .exemplar-login-row {
    align-items: stretch !important;
  }

  .cajupe-login-form-panel,
  .cajupe-login-visual,
  .exemplar-login-visual,
  .exemplar-login-form-panel {
    height: auto;
    min-height: 650px;
  }

  .exemplar-login-visual {
    align-self: stretch !important;
  }

  .cajupe-login-form,
  .exemplar-login-form {
    max-height: none;
    overflow: visible;
  }

  .exemplar-login-visual-image {
    position: absolute;
    inset: 0;
  }

  .cajupe-login-form-panel {
    padding: 2rem clamp(2rem, 3.5vw, 3.5rem) !important;
  }

  .cajupe-login-heading {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .cajupe-login-language {
    margin-top: 0.75rem;
  }

  .exemplar-login-form-panel {
    padding: 1.5rem clamp(1.75rem, 3vw, 3rem) !important;
  }

  .exemplar-login-logo {
    width: min(100%, 220px);
    max-height: 120px;
    margin-bottom: 0.65rem !important;
  }

  .preserve-login-app .exemplar-login-logo {
    width: 100px;
    max-height: 100px;
  }

  .exemplar-login-title {
    font-size: clamp(1.4rem, 1.8vw, 1.75rem);
  }

  .exemplar-login-description {
    margin-bottom: 0.7rem;
  }

  .exemplar-login-submit {
    margin-top: 1rem !important;
  }
}

/* Transição e ajustes */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.9s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.imgCajupe {
  position: relative;
  top: 150px;
  width: 100%;
  left: 410px;
}
.imgCajupeClient {
  position: relative;
  top: 250px;
  left: 200px;
  width: 100%;
  height: auto;
}
.textLogin {
  font-size: 30px;
  position: relative;
  top: 160px;
  left: 320px;
}
</style>
